var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forms"},[(_vm.submitted)?_c('Submitted',{attrs:{"submissionId":_vm.submissionId},on:{"resetEnquiry":_vm.resetEnquiry}}):_c('TheMarriageApplicationForm',{on:{"submitEnquiry":_vm.submitEnquiry}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }